import React, { FC, useMemo } from "react";
import { Avatar, Dropdown, Menu, Divider, Select } from "antd";
import { UserOutlined } from "@ant-design/icons";

import styles from "./styles.module.less";
import { LANG_MAP, changeLang, Lang, i18n } from "@/locales";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { IconFont } from "../IconFont";
import { useLocation } from "react-router";
export interface IProps {
  name: string;
  switchUserPoolHanlder: any;
}
export interface ISwitchTagProps {
  switchUserPoolHanlder: any;
}

export const PersonalCenterHeader: FC<{ menuConfig: any[] }> = ({
  menuConfig,
}) => {
  const photo = window.__user__?.photo;
  const avatarUrl = window.__config__?.userpoolLogo;
  const { t } = useTranslation();
  const location = useLocation();

  const handleChangeLang = (val: Lang) => {
    changeLang(val);
  };

  const isRootUserPool = useMemo(
    () => window.__userPoolId__ === window.__config__.rootUserPoolId,
    []
  );

  const redirectUris = window.__config__.redirectUris;
  const redirectUrl = redirectUris?.[0] || "/console/userpool";

  return (
    <>
      <div className={styles.header}>
        <div className={styles.leftWarp}>
          <div
            className={styles.logo}
            onClick={() => {
              isRootUserPool && (window.location.href = redirectUrl);
            }}
            style={{
              cursor: isRootUserPool ? "pointer" : "unset",
            }}
          >
            <img
              src={avatarUrl}
              className={styles.userpoolLogo}
              alt="Userpool"
            />
          </div>
          <Divider
            style={{
              margin: "10px 24px 10px 20px",
              height: "24px",
            }}
            type="vertical"
          />

          {location.pathname === `/u` ? (
            <span className={styles.title}>{t("common.personalCenter")}</span>
          ) : (
            <span className={styles.title}>
              {window.__config__.userpoolName}
            </span>
          )}
        </div>
        <div className={styles.aside}>
          {window.__userPoolId__ === window.__config__.rootUserPoolId && (
            <>
              <div
                className={classnames(styles.item, styles.itemHover)}
                onClick={() => {
                  window.location.href = "/console";
                }}
              >
                <IconFont
                  type="authing-server-line"
                  style={{
                    marginRight: 6,
                    fontSize: 13,
                  }}
                />
                {t("common.dashboard")}
              </div>
              <Divider
                style={{
                  margin: 10,
                  height: "24px",
                }}
                type="vertical"
              />
            </>
          )}

          <div className={styles.item}>
            <IconFont
              type="authing-language"
              style={{
                fontSize: 14,
              }}
            />
            <Select
              className={classnames(
                styles["header-selector"],
                styles["header-lang"]
              )}
              bordered={false}
              showArrow={false}
              value={i18n.language as Lang}
              onChange={handleChangeLang}
              dropdownMatchSelectWidth={90}
              dropdownClassName="lang-dropdown-style"
              dropdownStyle={{
                border: "1px solid #eaebee",
                borderRadius: 8,
                boxShadow: "0 0 12px 0 #F3F5F8",
                color: "#293350",
                minWidth: 70,
              }}
            >
              {LANG_MAP.map((lang) => (
                <Select.Option value={lang.value} key={lang.value}>
                  <span
                    style={{
                      color: "#515B78",
                    }}
                  >
                    {lang.label}
                  </span>
                </Select.Option>
              ))}
            </Select>
            <IconFont
              type="authing-arrow-down-line1"
              style={{
                fontSize: 14,
              }}
            />
          </div>
          <Dropdown
            overlayClassName={styles.headerDropdownOverlay}
            trigger={["click"]}
            overlay={
              <Menu>
                {menuConfig.map((menu, index) =>
                  menu.unShow && menu.unShow() ? null : (
                    <Menu.Item
                      onClick={menu.onClick}
                      style={{ paddingRight: 40 }}
                      key={index}
                    >
                      {menu.content}
                    </Menu.Item>
                  )
                )}
              </Menu>
            }
            overlayStyle={{
              minWidth: 120,
            }}
          >
            {photo ? (
              <img src={photo} alt="" className={styles.avatar} />
            ) : (
              <Avatar className={styles.item} icon={<UserOutlined />} />
            )}
          </Dropdown>
        </div>
      </div>
    </>
  );
};
